/* eslint-disable no-magic-numbers */
define('core/utils/guid',['core/utils/fingerprint'], function (fp) {
    'use strict';

    // necessary to increase entropy for the same client (and other clients in case when
    // window.crytpo is supported)
    //
    // @param {Object} deps Dependency injection. Optional. Needed for
    //                      when this code is executed on the host page,
    //                      where the built-in native objects may have
    //                      been altered.
    function random(deps) {
        deps = deps || {};
        var Uint32Array = deps.Uint32Array || window.Uint32Array;
        var crypto = deps.crypto || window.crypto;
        var Math = deps.Math || window.Math;
        try {
            // get cryptographically strong entropy when available (CryptoAPI)
            // NOTE: Cannot rely on return value of `crypto.getRandomValues`,
            // some implementations may not return anything
            // (including our test environment, PhantomJS)
            var ab = new Uint32Array(1);
            crypto.getRandomValues(ab);
            return ab[0];
        } catch (err) { // could throw QuotaExceededError if too much entropy is drained
            // fallback to old way
            return Math.floor(Math.random() * 1e9);
        }
    }

    function getNavigationTime() {
        var performance = window.performance;
        var timing = performance && performance.timing;

        // this method is expected to return a big number, so do this in any case
        if (!timing)
            return 1e5;

        var dns = timing.domainLookupEnd - timing.domainLookupStart;
        var connection = timing.connectEnd - timing.connectStart;
        var navigation = timing.responseStart - timing.navigationStart;

        // multiply values by random prime numbers just to decrease likelihood of
        // making the same sum by different summands
        return dns * 11 + connection * 13 + navigation * 17;
    }

    // NOTE: This GUID function does *NOT* generate RFC4122 v4 compatible GUIDs
    //       that has the format `xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx`
    //
    // @param {Object} deps Dependency injection. Optional. Needed for
    //                      when this code is executed on the host page,
    //                      where the built-in native objects may have
    //                      been altered.
    function generateGUID(deps) {
        deps = deps || {};
        var Math = deps.Math || window.Math;

        // With all the fanciness above, we're going to generate a 'unique'
        // ID as an impression.

        // remove 3 most significant digits as they don't change often
        var time = Number(new Date().getTime().toString().substring(3));

        // Doing only arithmetic operations here as bitwise/shifts only operate on int32.
        // impId consists into two parts which should be independently random. Each part is
        // converted to number with base 32 in order to minimize overall length of the impId,
        // but still keep it very random (14^32 different strings)
        var guid = Math.abs(time + getNavigationTime() - fp.get()).toString(32);
        guid += random(deps).toString(32);
        return guid;
    }

    return { generate: generateGUID };
});

